import * as S from './resources-tile';

const TRAINING_SITE_URL = 'https://truecomp.com/training/';
const SUPPORT_URL = 'https://govinvest.atlassian.net/servicedesk/customer/portal/1';

export default function ResourcesTile() {
  return (
    <S.SectionContainer>
      <S.ModulesContainer>
        <S.ListContainer>
          <S.ContainerTitle>Training Site</S.ContainerTitle>
          <S.LinkGroup>
            <S.Link
              href={TRAINING_SITE_URL}
              target='_blank'
              rel='noreferrer'>
              Advance Your Expertise with TrueComp Training
            </S.Link>
          </S.LinkGroup>
        </S.ListContainer>
        <S.ListContainer>
          <S.ContainerTitle>Support Link</S.ContainerTitle>
          <S.LinkGroup>
            <S.Link
              href={SUPPORT_URL}
              target='_blank'
              rel='noreferrer'>
              GovInvest/TrueComp Support - Jira Service Management
            </S.Link>
          </S.LinkGroup>
        </S.ListContainer>
      </S.ModulesContainer>
    </S.SectionContainer>
  );
}
